import { featureIdentifiers } from '../../constants';

const useSubscriptionPlanHelper = (plan) => {
  const { features = [] } = plan ?? {};

  const getFeatureValue = (identifier) => {
    return features.find((c) => c.identifier === identifier)?.value;
  };

  return { getFeatureValue, identifiers: featureIdentifiers };
};

export default useSubscriptionPlanHelper;
